import axios from "axios";
import { Poi } from "../types";
import { callWsCached } from "../utils";


function getPois(
  siteBasePath: string,
    id: number
  ): Promise<Poi[]> {
    let url = `/api/poi/list-pth/${id}`;
    url = `${siteBasePath}${url}`;
    return axios({ method: "get", url }).then(resp => {
      let pois = Object.values(resp);
      return pois;
    });
}

export default async function(
    siteBasePath: string,
    network: string,
    id: number
  ): Promise<Poi[]> {
    let prefix = `server-${network}-${siteBasePath}-`;
    let key = `${prefix}-pois-${id}`;

    let proxyGetValue: Function = callWsCached(
      key,
      () => getPois(siteBasePath.replace(/\/$/, ''), id)
    );

    let proxiedValue = await proxyGetValue();

    return JSON.parse(JSON.stringify(proxiedValue[0]));
  }
